<template>
  <InputDefault
    v-model="model"
    type="text"
    pre-icon="TimeIcon"
    class="py-3 ps-10 pe-4 block w-full border-gray-400 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
    :clear="clear" :clear-event="clearEvent" v-bind="$attrs"  @click="openTimeClick()"  />
  <div
    :id="'time_content_' + $attrs.id"
    class="absolute hidden w-80 md:w-[40.4rem] flex flex-col bg-white border shadow-lg rounded-xl overflow-hidden dark:bg-neutral-900 dark:border-neutral-700">
    <div :class="`mt-3 flex justify-center items-center gap-x-2`">
      <!-- Select -->
      <div class="relative">
        <select :id="'calendar_horas_' + $attrs.id" :data-hs-select="jsonhora" class="hidden">
          <option value="0">0</option>
          <template v-for="i in 23" :key="i">
            <option v-if="i == horaactual" :value="i" selected>{{ i }}</option>
            <option v-else :value="i">{{ i }}</option>
          </template>
        </select>
        <div class="absolute top-1/2 end-2 -translate-y-1/2">
          <ChevronUpDownIcon class="shrink-0 size-3 text-gray-500 dark:text-neutral-500"></ChevronUpDownIcon>
        </div>
      </div>
      <span class="text-gray-800 dark:text-white">:</span>
      <div class="relative">
        <select :id="'calendar_min_' + $attrs.id" :data-hs-select="jsonmin" class="hidden">
          <option value="00">00</option>
          <template v-for="i in 59" :key="i">
            <option v-if="i == minactual" :value="i > 9 ? i : `0${i}`" selected>{{ i > 9 ? i : `0${i}` }}</option>
            <option v-else :value="i > 9 ? i : `0${i}`">{{ i > 9 ? i : `0${i}` }}</option>
          </template>
        </select>

        <div class="absolute top-1/2 end-2 -translate-y-1/2">
          <ChevronUpDownIcon class="shrink-0 size-3 text-gray-500 dark:text-neutral-500"></ChevronUpDownIcon>
        </div>
      </div>
    </div>
    <div class="flex justify-end items-center gap-x-2 p-3 border-t dark:border-neutral-700">
      <button
        type="button"
        class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-400 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800"
        @click="closeTimeClick">
        Cerrar
      </button>
      <button
        type="button"
        class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
        @click="setValor">
        Aplicar
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useAttrs, ref } from 'vue';
import { ChevronUpDownIcon } from '@heroicons/vue/24/outline';
const attrs = useAttrs()
const model = defineModel<string>();
const horaactual = ref<number | null>(null);
const minactual = ref<number | null>(null);
const props = defineProps({
  id: String,
  clear: {
    type: Boolean,
    default: false
  },
  clearEvent: Function
})
function openTimeClick() {
  const el = document.getElementById('time_content_' + attrs.id);
  if (el) el.classList.remove("hidden")
}
function closeTimeClick() {
  const el = document.getElementById('time_content_' + attrs.id);
  if (el) el.classList.add("hidden")
}
const cargarTime = async ({ hour, min }: { hour: number, min: number }) => {
  horaactual.value = hour;
  minactual.value = min;
}
const maptime = (nuevasPropiedades: string) => {
  const hour = parseInt(nuevasPropiedades.split(':')[0])
  const min = parseInt(nuevasPropiedades.split(':')[1])
  return { hour, min }
}
cargarTime(maptime((model.value || '00:00')))
const jsonhora: string = JSON.stringify({
  "placeholder": "Select option...",
  "viewport": '#time_content_' + attrs.id,
  "toggleTag": "<button type=\"button\"></button>",
  "toggleClasses": "hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50 relative py-1 px-2 pe-6 flex text-nowrap w-full cursor-pointer bg-white border border-gray-400 rounded-lg text-start text-sm focus:border-blue-500 focus:ring-blue-500 before:absolute before:inset-0 before:z-[1] dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400",
  "dropdownClasses": "mt-2 z-50 w-full min-w-24 max-h-72 p-1 space-y-0.5 bg-white border border-gray-400 rounded-lg overflow-hidden overflow-y-auto dark:bg-neutral-900 dark:border-neutral-700",
  "optionClasses": "hs-selected:bg-gray-100 dark:hs-selected:bg-neutral-800 py-2 px-4 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100 dark:hs-selected:bg-gray-700 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:text-neutral-200 dark:focus:bg-neutral-800",
  "optionTemplate": "<div class=\"flex justify-between items-center w-full\"><span data-title></span></div>"
})
const jsonmin: string = JSON.stringify({
  "placeholder": "Select option...",
  "viewport": '#time_content_' + attrs.id,
  "toggleTag": "<button type=\"button\"></button>",
  "toggleClasses": "hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50 relative py-1 px-2 pe-6 flex text-nowrap w-full cursor-pointer bg-white border border-gray-400 rounded-lg text-start text-sm focus:border-blue-500 focus:ring-blue-500 before:absolute before:inset-0 before:z-[1] dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400",
  "dropdownClasses": "mt-2 z-50 w-full min-w-24 max-h-72 p-1 space-y-0.5 bg-white border border-gray-400 rounded-lg overflow-hidden overflow-y-auto dark:bg-neutral-900 dark:border-neutral-700",
  "optionClasses": "hs-selected:bg-gray-100 dark:hs-selected:bg-neutral-800 py-2 px-4 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100 dark:hs-selected:bg-gray-700 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:text-neutral-200 dark:focus:bg-neutral-800",
  "optionTemplate": "<div class=\"flex justify-between items-center w-full\"><span data-title></span></div>"
})
const setValor = () => {
  const selectHour = document.getElementById('calendar_horas_' + props.id) as HTMLInputElement
  const selectMin = document.getElementById('calendar_min_' + props.id) as HTMLInputElement
  if (selectHour && selectMin)
    model.value = `${selectHour.value}:${selectMin.value}`
}
</script>
